/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Ext_Device_ConfirmInputs */

const en_creator_ext_device_confirm = /** @type {(inputs: Creator_Ext_Device_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, enable`)
};

const fr_creator_ext_device_confirm = /** @type {(inputs: Creator_Ext_Device_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, activer`)
};

const de_creator_ext_device_confirm = /** @type {(inputs: Creator_Ext_Device_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, aktivieren`)
};

const it_creator_ext_device_confirm = /** @type {(inputs: Creator_Ext_Device_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, abilita`)
};

const ru_creator_ext_device_confirm = /** @type {(inputs: Creator_Ext_Device_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да, включить`)
};

const es_creator_ext_device_confirm = /** @type {(inputs: Creator_Ext_Device_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, habilitar`)
};

const zh_cn2_creator_ext_device_confirm = /** @type {(inputs: Creator_Ext_Device_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的，启用`)
};

const ja_creator_ext_device_confirm = /** @type {(inputs: Creator_Ext_Device_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、有効にします`)
};

const hi_creator_ext_device_confirm = /** @type {(inputs: Creator_Ext_Device_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हां, सक्षम करें`)
};

const pt_pt2_creator_ext_device_confirm = /** @type {(inputs: Creator_Ext_Device_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, habilite`)
};

/**
* | output |
* | --- |
* | "Yes, enable" |
*
* @param {Creator_Ext_Device_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_ext_device_confirm = /** @type {((inputs?: Creator_Ext_Device_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Ext_Device_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_creator_ext_device_confirm(inputs)
	if (locale === "de") return de_creator_ext_device_confirm(inputs)
	if (locale === "it") return it_creator_ext_device_confirm(inputs)
	if (locale === "ru") return ru_creator_ext_device_confirm(inputs)
	if (locale === "es") return es_creator_ext_device_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_creator_ext_device_confirm(inputs)
	if (locale === "ja") return ja_creator_ext_device_confirm(inputs)
	if (locale === "hi") return hi_creator_ext_device_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_creator_ext_device_confirm(inputs)
	return en_creator_ext_device_confirm(inputs)
});